<template>
  <div class="row receitas">
    <public-header :title="title">
      <ano-base />
      <div class="col-sm-6">

        <p>
          Aqui você encontra um resumo dos(as)
          <span class="destaque-header">{{ title }}</span>
          recebidas pela Prefeitura
          Municipal de Santos.
        </p>

        <p>
          A Prefeitura Municipal de Santos, no ano de
          <span class="destaque-header">{{ anoAtual }}</span>
          até o mês de
          <span class="destaque-header">{{ retornaMesComparativo }}</span>, 
          arrecadou de  
          <span class="destaque-header">{{ title }}</span>
          um total de
          <span class="destaque-header">{{ filtrarPorCodigo(receitaID).atual.vl_total }}</span>
          de um orçamento estimado para este ano de
          <span class="destaque-header">{{ filtrarPorCodigo(receitaID).atual.vl_atualizado }}</span>.
        </p>

      </div>
      <div class="col-sm-6">
        <p>
          <bar-chart
            ref="receita_mensal"
            :chart-data="graficoHeader"
            :gradiente="false"
            :coloredLine="true"
            :options="{
              responsive: true,
              maintainAspectRatio: false,
              legend: {
                display: true,
                labels: {
                  fontColor: '#C1D1C1',
                },
              },
              scales: {
                yAxes: [
                  {
                    ticks: {
                      beginAtZero: true,
                      suggestedMax: 50,
                      fontColor: '#C1D1C1',
                      callback: function (value, index, values) {
                        return value.toLocaleString('pt-br', {
                          style: 'currency',
                          currency: 'BRL',
                        })
                      },
                    },
                  },
                ],
                xAxes: [
                  {
                    maxBarThickness: 50,
                    ticks: {
                      fontColor: '#C1D1C1',
                    },
                  },
                ],
              },
              tooltips: {
                callbacks: {
                  label: function (tooltip, dataset) {
                    var xLabel = dataset.datasets[tooltip.datasetIndex].label
                    var yLabel = tooltip.yLabel.toLocaleString('pt-br', {
                      style: 'currency',
                      currency: 'BRL',
                    })
                    return xLabel + ': ' + yLabel
                  },
                },
              },
            }"
          ></bar-chart>
        </p>
      </div>
    </public-header>
    <div class="container">
      <div class="row">
        <ol class="breadcrumb">
          <li v-for="(link, index) in breadcrumbLinks" :key="index">
            <router-link :to="link.url">{{ link.descricao }}</router-link>
          </li>

          <li class="">{{ title }}</li>
        </ol>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <h2>Arrecadações em Destaque</h2>
        </div>
      </div>

      <div class="row">
        <card :data="dataCards" />
      </div>
    </div>
  </div>
</template>

<script>
import { BarChart, PublicHeader, AnoBase } from '@/components/common/'
import colors from '@/utils/colors.js'
import Card from '../Card'

import { mapState } from 'vuex'

export default {
  components: { PublicHeader, BarChart, Card, AnoBase },
  data() {
    return {
      cores: [],
      graficos_base: { labels: [], datasets: [{ label: '', data: [] }] },
    }
  },
  created() {
    this.cores = [...colors.coresHexa]
  },
  mounted() {
    window.scrollTo(0, 0)
  },
  methods: {
    filtrarPorCodigo(codigo) {
      const { receitas_proprias } =
        this.$store.state.receitas_despesas

      const filterByID = (obj) => {
        if ('cd_plano_conta_rel' in obj && obj.cd_plano_conta_rel === codigo) {
          return true
        } else {
          return false
        }
      }

      const receitasAtual = receitas_proprias.filter(filterByID)

      if (receitasAtual.length === 0)
        return false
      else
        return {
          atual: { ...receitasAtual[0] },
        }
    },
    getDataCards() {
      const { receitaID, hasLinks } = this
      const contas = this.getSubContas(receitaID)
      const datacards = []

      contas.atual.forEach(contaAtual => {
        const {
          cd_plano_conta_rel: codigo,
          ds_plano_conta: title,
          vl_total,
          vl_atualizado,
          vl_total_f,
          vl_atualizado_f
        } = contaAtual

        const percentual = vl_atualizado_f > 0 ? (vl_total_f / vl_atualizado_f * 100).toFixed(0) : '---'

        const data = [
          { label: 'Previsão Anual', value: vl_atualizado },
          { label: 'Arrecadado', value: vl_total },
          {
            label: 'Percentual',
            value: `Arrecadado aproximadamente ${percentual}% da previsão`,
          },
        ]

        const item = { codigo, title, data }

        if (hasLinks(contaAtual)) item.link = `/receitas/detalhes/${codigo}/`

        datacards.push(item)
      });

      return datacards
    },
    getSubContas(codigo) {
      const { receitas_proprias } = this.$store.state.receitas_despesas
      const nivelAtual = codigo.split('.').length
      let atual = []

      const contaProximoNivel = receitas_proprias.find(({ cd_plano_conta_rel, nivel }) => cd_plano_conta_rel.indexOf(codigo) === 0 && nivel > nivelAtual)

      if (contaProximoNivel) {
        const { nivel: proximoNivel } = contaProximoNivel
        atual = receitas_proprias.filter(({ cd_plano_conta_rel, nivel }) => cd_plano_conta_rel.indexOf(codigo) === 0 && nivel === proximoNivel)
      }

      return { atual }
    },
    hasLinks(conta) {
      const { receitas_proprias } = this.$store.state.receitas_despesas
      const { cd_plano_conta_rel: codigo } = conta
      const nivelAtual = codigo.split('.').length

      const { length: contasAtualCount }  = receitas_proprias.filter(({ cd_plano_conta_rel, nivel }) => cd_plano_conta_rel.indexOf(codigo) === 0 && nivel > nivelAtual)

      return contasAtualCount > 0
    },
    getContaCodigoAnterior(codigo) {
      const array = String(codigo).split('.')
      let receita = undefined

      do {
        array.pop()
        let codigoAnterior = array.join('.')
        receita = this.getReceita(codigoAnterior)
        
      } while (receita === undefined && array.length > 1)

      return receita ? receita.cd_plano_conta_rel : false
    },
    getReceita(codigo) {
      const { receitas_proprias } = this.$store.state.receitas_despesas
      const receita = receitas_proprias.find(item => item.cd_plano_conta_rel === codigo)

      return receita
    }
  },
  computed: {
    ...mapState({
      anoAtual: state => state.receitas_despesas.ano_base
    }),
    retornaMesComparativo () {
      const data = new Date()
      if (this.anoAtual !== data.getFullYear()) {
        return new Date(this.anoAtual, 11, 31).toLocaleString('default', { month: 'long' })
      }

      return data.toLocaleString('default', { month: 'long' })
    },
    receitaID() {
      return String(this.$route.params.id)
    },
    title() {
      const { getReceita, receitaID } = this
      const receita = getReceita(receitaID)

      return receita ? receita.ds_plano_conta : 'Ops este código de receita não foi encontrado!'
    },
    breadcrumbLinks() {
      const { getContaCodigoAnterior, receitaID } = this
      const linksDefault = [
        { descricao: 'Início', url: '/' },
        { descricao: 'Receitas e Despesas', url: '/receitas_despesas' },
        { descricao: 'Receitas', url: '/receitas' }
      ]

      let codigo = receitaID

      if (codigo.length === 1) return linksDefault

      const links = []

      do {
        const codigoAnterior = getContaCodigoAnterior(codigo)
        const receitaAnterior = this.getReceita(codigoAnterior)

        if (receitaAnterior) {
          const { ds_plano_conta: descricao } = this.getReceita(codigoAnterior)
          const url = `/receitas/detalhes/${codigoAnterior}/`

          links.push({ descricao, url })  
        }
        
        codigo = codigoAnterior
      } while (codigo.length > 1)

      return [ ...linksDefault, ...links.reverse() ]
    },
    dataCards () {
      return this.getDataCards()
    },
    graficoHeader() {
      const { receitaID, filtrarPorCodigo } = this
      const labels = [
        'Jan',
        'Fev',
        'Mar',
        'Abr',
        'Mai',
        'Jun',
        'Jul',
        'Ago',
        'Set',
        'Out',
        'Nov',
        'Dez',
      ]
      const dados = filtrarPorCodigo(receitaID)
      let data = []

      for (let index = 0; index < labels.length; index++) {
        const element = labels[index].toLowerCase()
        data.push(dados.atual[`vl_${element}_f`])
      }

      return {
        ...this.graficos_base,
        labels,
        datasets: [
          {
            label: `Receita Mensal - ${this.anoAtual}`,
            backgroundColor: this.cores[0],
            data: data,
          },
        ],
      }
    },
  },
}
</script>

<style scoped>
.receitas {
  margin-bottom: 30px;
}
</style>


// WEBPACK FOOTER //
// src/views/public/receitas_despesas/receitas/Detalhes.vue